import { useMemo, useState } from 'react';
import { NumberFormattedField } from 'components';
import WaterfallDistributionTable from './components/WaterfallDistributionTable';
import { buildDistributionRows } from './compute';
import { useNumberFormattedFiedStyles } from './styles';
import { IWaterfallCalculatorProps } from './types';

const WaterfallCalculator = ({ data, isLoading }: IWaterfallCalculatorProps) => {
  const [exitEquityValue, setExitEquityValue] = useState<string>('');

  const classes = useNumberFormattedFiedStyles();

  const rows = useMemo(() => buildDistributionRows(exitEquityValue, data), [exitEquityValue, data]);

  return (
    <>
      <div className={classes.equityValueInput}>
        <span className={classes.equityValueLabel}>Exit Equity Value</span>
        <div className={classes.equityValueField}>
          <NumberFormattedField
            id="exit-equity-value"
            type="text"
            name="exitEquityValue"
            label=""
            value={exitEquityValue}
            onChange={e => setExitEquityValue(e.target.value)}
            currencyCode="USD"
            format="currency"
            variant="outlined"
          />
        </div>
      </div>
      <WaterfallDistributionTable rows={rows} isLoading={isLoading} />
    </>
  );
};

export default WaterfallCalculator;
